/**
 * Prefer codecs by mimetype
 *
 * This produces a reordered list of codecs with the preferred codecs first.
 *
 * @param codecs The codecs to rearrange
 * @param mimeType The mimetype to prefer
 * @returns
 */
export const preferCodec = (codecs: RTCRtpCodecCapability[], mimeType: string): RTCRtpCodecCapability[] => {
  const otherCodecs: RTCRtpCodecCapability[] = [];
  const sortedCodecs: RTCRtpCodecCapability[] = [];

  if (!codecs) {
    return [];
  }

  codecs.forEach((codec) => {
    if (codec.mimeType === mimeType) {
      sortedCodecs.push(codec);
    } else {
      otherCodecs.push(codec);
    }
  });

  return sortedCodecs.concat(otherCodecs);
};

/**
 *
 * @param codecs Codecs to filter
 * @param mimeType The mimetype to filter for
 * @param sdpFormatFilter A sdp format filter to use, optionally. Allow for filtering specific profiles
 * @returns
 */
export const filterCodecs = (
  codecs: RTCRtpCodecCapability[],
  mimeType: string,
  sdpFormatFilter?: string,
): RTCRtpCodecCapability[] => {
  return codecs.filter((codec) => {
    if (codec.mimeType !== mimeType) {
      return false;
    }
    if (sdpFormatFilter && !codec.sdpFmtpLine?.includes(sdpFormatFilter)) {
      return false;
    }
    return true;
  });
};

/**
 * Close an RTCPeerConnection, removing all event listeners
 * @param peer The peer to close
 */
export const closeRtcPeer = (peer?: RTCPeerConnection): void => {
  if (!peer) {
    return;
  }
  peer.onconnectionstatechange = null;
  peer.ondatachannel = null;
  peer.onicecandidate = null;
  peer.onicecandidateerror = null;
  peer.oniceconnectionstatechange = null;
  peer.onicegatheringstatechange = null;
  peer.onnegotiationneeded = null;
  peer.onsignalingstatechange = null;
  peer.ontrack = null;
  peer.close();
};
